<div id="tamanho-maximo-anexos">
  <table>
    <thead>
      <tr>
        <th>Tipo de arquivo</th>
        <th>Extensão</th>
        <th>Tamanho máximo</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Documento</td>
        <td>pdf</td>
        <td>10 Mb</td>
      </tr>
      <tr>
        <td rowspan="2">Imagem</td>
        <td>png</td>
        <td>3 Mb</td>
      </tr>
      <tr>
        <td>jpeg</td>
        <td>3 Mb</td>
      </tr>
      <tr>
        <td rowspan="4">Vídeo</td>
        <td>mpeg</td>
        <td>50 Mb</td>
      </tr>
      <tr>
        <td>ogg</td>
        <td>50 Mb</td>
      </tr>
      <tr>
        <td>mp4</td>
        <td>50 Mb</td>
      </tr>
      <tr>
        <td>quicktime (.mov)</td>
        <td>50 Mb</td>
      </tr>
      <tr>
        <td rowspan="6">Áudio</td>
        <td>mpeg</td>
        <td>10 Mb</td>
      </tr>
      <tr>
        <td>mp3</td>
        <td>10 Mb</td>
      </tr>
      <tr>
        <td>ogg</td>
        <td>10 Mb</td>
      </tr>
      <tr>
        <td>mp4</td>
        <td>10 Mb</td>
      </tr>
      <tr>
        <td>vorbis</td>
        <td>10 Mb</td>
      </tr>
      <tr>
        <td>wav</td>
        <td>50 Mb</td>
      </tr>
    </tbody>
  </table>
</div>
<mat-dialog-actions>
  <button mat-button (click)="fechar()">Fechar</button>
</mat-dialog-actions>
